import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { AuditRoleStatusBadge } from "PFComponents/audit_role_status/audit_role_status_badge";
import { Inline } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Pill } from "PFComponents/pill";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { isUserParticipating, useActivityNameAndId } from "PFCore/helpers/activities";
import { useInvites } from "PFCore/hooks/queries/invites/use_invites";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { useTranslation } from "react-i18next";

import { TagSection } from "../../tag/tag_section";
import css from "./core_information_row.module.scss";

export const CoreInformationRow = () => {
  const { t } = useTranslation(["core", "translation", "activities", "auditPlanner"]);
  const activity = useCurrentActivity();
  const { isAudit, isRole } = useActivityShowContext();
  const { data: currentProfile } = useCurrentProfile();
  const { data: invites } = useInvites(activity.id);
  const getActivityNameId = useActivityNameAndId();

  const { id } = getActivityNameId(activity);
  const isCurrentProfileParticipant = isUserParticipating(activity, currentProfile.id);
  const markAsInvited =
    !activity.coowned && invites && !!invites.find((invite) => invite.profileId === currentProfile.id);
  const getRoleStatusTitle = (state: string) => t("core:roleStatus.workflowState.title", { state });
  const getAuditRoleStatusTitle = (state: string) =>
    t("auditPlanner:auditRoleState.workflowState.title", { state });

  return (
    <Inline alignItems="center" qaId="ActivityDetailsTags" wrap="wrap">
      <TagSection activity={activity} />
      {isRole &&
        (isAudit ? (
          <AuditRoleStatusBadge workflowState={activity.workflow_state} getTitle={getAuditRoleStatusTitle} />
        ) : (
          <RoleStatusBadge workflowState={activity.workflow_state} getTitle={getRoleStatusTitle} />
        ))}
      {isCurrentProfileParticipant && <Pill text={t("activities:show.details.pillParticipant")} small />}
      {!isCurrentProfileParticipant && markAsInvited && (
        <Pill text={t("activities:show.details.pillShared")} small />
      )}
      {id && <ReadOnlyField label={t("activities:show.details.id")} value={id} inline />}
      {id && <Divider type="vertical" className={css.divider} />}
      <ReadOnlyField
        label={t("activities:show.details.state")}
        value={t(`core:roleStatus.state.${activity?.state}`)}
        inline
      />
      <Divider type="vertical" className={css.divider} />
      <ReadOnlyField
        label={t("translation:privacy")}
        value={activity.private ? t("translation:privatePrivacy") : t("translation:publicPrivacy")}
        inline
      />
    </Inline>
  );
};
